<div>
  <app-base-report *ngIf="errorLoggerReportData"
                   [hasDateRangeFilter]="true"
                   [hasCheckboxes]="false"
                   [reportName]="'Error Logger Report'"
                   [defaultColumns]="tableColumns"
                   [columnsDisplayNames]="displayTableColumns"
                   [data]="errorLoggerReportData"
                   [rowsLength]="totalNumberOfRecords"
                   (filterTrigger)="filter($event)"
                   (paginationChange)="paginate($event)"
                   (searchChange)="searchChance($event)"
                   [hasSort]="true"
                   (sortTrigger)="sortChange($event)"
                   [serviceInstance]="fetchErrorsLoggedService"></app-base-report>
</div>
